module.exports = __webpack_public_path__ + "017ef5c30708f1966fb1af478545eef8.svg";